module.exports = __webpack_public_path__ + "static/media/PhoneGreen.6692f408.svg";